/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Video, { type VideoProps } from 'components/Video/Video';
import Statement from '../Statement/Statement';
import './ProfileVideo.scss';

interface ProfileVideoProps extends VideoProps {
  layout?: string;
  intro?: string;
}

/**
 * This is the ProfileVideo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function ProfileVideo({
  layout = 'left',
  intro = '',
  ...props
}: ProfileVideoProps) {
  return (
    <div className={`block profile-video layout-${layout}`}>
      <div className="video-container" appear="true">
        <Video {...props} />
      </div>
      <Statement limit={30}>{intro}</Statement>
    </div>
  );
}

export default ProfileVideo;
